<template>
	<div>
		<h2 class="content-block">Dashboard</h2>
		
		<DxPopup :visible="showActionEditor" :defer-rendering="true" :show-title="true" title="Action Editor" :show-close-button="true" width="80%" height="80%" @hidden="showActionEditor = false" :wrapper-attr="{ class: 'no-padding-popup' }">
			<template #content>
				<ActionEditor :graph-id="1" />
			</template>
		</DxPopup>
		<div class="content-block">
			<!-- <DxButton @click="showActionEditor = true">Show Action Editor</DxButton> -->
		</div>
		<!-- Quick instruction columns using flexible layout -->
		<div class="instructions-row">
			<div class="instruction-strip">
				<div class="instruction-strip__icon"><i class="dx-icon dx-icon-arrowleft"></i></div>
				<div class="instruction-strip__title">Access Pages</div>
				<img class="instruction-strip__img" src="/stock-file-upload.jpg" alt="Access Data" />
				<div class="instruction-strip__body">
					<p>Access pages within the website to manage your data, upload files, take notes. Use the menu on the left to visit the appropriate page.</p>
					<!--<DxButton class="instruction-strip__link-btn" text="Open File Drive" type="default" styling-mode="contained" @click="goToDrive" />-->
				</div>
			</div>
			<div class="instructions-spacer"></div>
			<div class="instruction-strip instruction-strip--right">
				<div class="instruction-strip__icon"><i class="dx-icon dx-icon-arrowup"></i></div>
				<div class="instruction-strip__title">Ask questions</div>
				<img class="instruction-strip__img" src="/stock-ai-question.jpg" alt="Ask questions" />
				<div class="instruction-strip__body">
					<p>Use the question button in the top‑right to ask questions about your data, files or notes, from anywhere.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.no-padding-popup {
	.dx-popup-content {
		padding: 0 !important;
	}
}

/* Instruction layout (flex/grid without fixed positioning) */
.instructions-row {
	display: flex;
	align-items: stretch;
	gap: 16px;
	margin: 16px 16px 24px 16px;
	min-height: 60vh;
}

.instructions-spacer {
	flex: 1 1 auto;
}

.instruction-strip {
	width: 220px;
	background: rgba(255, 255, 255, 0.9);
	border: 1px solid #e1e5ee;
	border-radius: 10px;
	box-shadow: 0 4px 18px rgba(0,0,0,0.08);
	padding: 14px 14px 24px 14px;
}

.instruction-strip--right {
	margin-right: 220px; /* offset from the right edge */
}

.instruction-strip__title {
	font-weight: 600;
	font-size: 21px;
	margin-bottom: 8px;
	color: #334155;
	text-align: center;
}

.instruction-strip__body {
	font-size: 14px;
	font-style: italic;
	line-height: 1.35;
	color: #475569;
	position: relative;
	text-align: center;
}

.instruction-strip__link {
	display: inline-block;
	margin-top: 10px;
	color: #0ea5e9;
	text-decoration: none;
	font-weight: 600;
}

.instruction-strip__link:hover { text-decoration: underline; }

.instruction-strip__link-btn {
	margin-top: 10px;
	width: 100%;
}

/* Big DevExtreme icon at the top */
.instruction-strip__icon {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;
}

.instruction-strip__icon .dx-icon {
	font-size: 64px;
	line-height: 1;
	color: #009688;
}

.instruction-strip__img {
	display: block;
	width: calc(100% + 28px);
	height: 240px;
	object-fit: cover;
	object-position: 73% 50%;
	margin-left: -14px;
	margin-right: -14px;
	filter: sepia(25%);

}
</style>

<script setup>
/* eslint-disable */
import { ref, computed } from 'vue';
import ActionEditor from '../components/actions/action-editor.vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue';

const showActionEditor = ref(false);

const goToDrive = () => {
	window.location.href = '/#/demo/file-drive';
};

</script>